


























import Vue from 'vue';
import Component from 'vue-class-component';
import Editor from './Editor.vue';
import FileUpload from './FileUpload.vue';
import adBlockerDetector from '../helpers/adBlockerDetector';

@Component({
  name: 'ReplyForm',

  components: {
    Editor,
    FileUpload,
  },
})
export default class ReplyForm extends Vue {
  message = '';

  files = [];

  adBlockerEnabled = false;

  mounted() {
    adBlockerDetector().then((result: boolean) => {
      this.adBlockerEnabled = result;
    });
  }

  onSubmit() {
    this.$emit('submit', {
      message: this.message,
      files: this.files,
      adBlockerEnabled: this.adBlockerEnabled,
    });
  }
}
